import { NfStatus } from './nf-status.enum';

export interface NfDocumentResponse {
  id: number;
  accessKey: string;
  series: string;
  nfNumber: string;
  addedOn: string | null;
  addedBy: string | null;
}

export interface NfConsentResponse {
  id: number;
  consentedBy: string;
  consentedOn: string;
  statusAtConsent: NfStatus;
}

export interface NfStatusHistoryResponse {
  status: NfStatus;
  changedBy: string;
  changedOn: string;
}

export interface NfVerificationResponse {
  id: number;
  hubId: number;
  truckId: number;
  status: NfStatus;
  operatorEmail: string;
  truckPlate: string;
  truckPlateCountry: string;
  driverName: string;
  driverPhone: string;
  createdOn: string;
  statusChangedOn: string;
  closedOn: string | null;
  documents: NfDocumentResponse[];
  uliNumbers: string[];
  consents: NfConsentResponse[];
}

export interface NfStatusUpdateRequest {
  status: NfStatus;
}
